module.exports = __webpack_public_path__ + "img/discount-shape.afda6892.png";